import {Box, Colors, Text} from "@bounce/shared/ui";
import {ReachAccountSearchResult} from "../../../apis/requests/accounts/searchAccounts";

const formatCents = (cents: number | null): string | null =>
  cents == null ? null : (cents / 100).toLocaleString("en-US", {style: "currency", currency: "USD"});

const AccountInfoPanel = ({account}: {account: ReachAccountSearchResult}) => {
  const rows: [string, string | number | null][] = [
    ["account_public_id", account.account_public_id],
    ["external_account_id", account.external_account_id],
    ["email", account.email],
    ["phone", account.phone],
    ["current_creditor", account.current_creditor],
    ["product", account.product],
    ["balance", formatCents(account.total_balance)],
  ];
  return (
    <Box
      sx={{
        border: `1px solid ${Colors.tertiary._300}`,
        borderRadius: "10px",
        backgroundColor: Colors.tertiary._100,
        px: 2,
        py: 1.5,
        display: "grid",
        gridTemplateColumns: "max-content 1fr",
        columnGap: 2,
        rowGap: 0.5,
      }}
    >
      {rows.map(([label, value]) => (
        <Box key={label} sx={{display: "contents"}}>
          <Text size={11} sx={{color: Colors.grey._500, fontFamily: "monospace", lineHeight: 1.8}}>
            {label}
          </Text>
          <Text
            size={11}
            sx={{
              color: Colors.grey._800,
              fontFamily: "monospace",
              lineHeight: 1.8,
              wordBreak: "break-word",
            }}
          >
            {value == null || value === "" ? "—" : value}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default AccountInfoPanel;
